(() => {
  const initialize = () => {
    document.querySelectorAll('[data-gd-care]').forEach((panel) => {
      if (panel.dataset.ready) return;
      const select = panel.querySelector('[data-gd-care-select]');
      const form = panel.closest('form');
      if (!select || !form) return;
      panel.dataset.ready = 'true';
      const details = panel.querySelector('[data-gd-care-details]');
      const error = panel.querySelector('[data-gd-care-error]');
      const review = panel.querySelector('[data-gd-care-review]');
      const quantity = form.querySelector('[name="quantity"]');
      const payment = form.querySelector('.gd-payment');
      const originalMax = quantity?.getAttribute('max');
      const button = form.querySelector('[name="add"]');
      select.disabled = false;
      const update = () => {
        const option = select.selectedOptions[0];
        const selected = Boolean(select.value);
        details.hidden = !selected;
        if (selected) details.href = option.dataset.url;
        else details.removeAttribute('href');
        if (payment) payment.hidden = selected;
        error.hidden = true;
        review.hidden = true;
        if (quantity) {
          const limits = [originalMax, selected ? option.dataset.max : null].filter((x) => x != null && x !== '').map(Number);
          if (limits.length) quantity.max = String(Math.min(...limits));
          else quantity.removeAttribute('max');
        }
      };
      select.addEventListener('change', update);
      update();
      form.addEventListener('submit', async (event) => {
        if (!select.value) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (panel.dataset.busy || !form.reportValidity()) return;
        panel.dataset.busy = 'true';
        const parentId = Number(form.querySelector('[name="id"]').value);
        const count = Number(quantity?.value || 1);
        const planId = Number(select.value);
        if (!Number.isSafeInteger(parentId) || !Number.isSafeInteger(planId) || !Number.isSafeInteger(count) || count < 1) {
          delete panel.dataset.busy;
          return;
        }
        button.disabled = true;
        select.disabled = true;
        error.hidden = true;
        const pair = crypto.randomUUID();
        const parentProperties = { _gd_care_pair: pair };
        const planProperties = { _gd_care_pair: pair, Equipment: panel.dataset.parentTitle, 'Equipment SKU': panel.dataset.parentSku };
        try {
          const response = await fetch(panel.dataset.addUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [
              { id: parentId, quantity: count, properties: parentProperties },
              { id: planId, quantity: count, parent_id: parentId, properties: planProperties }
            ] })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : panel.dataset.error);
          window.location.assign(panel.dataset.cartUrl);
        } catch {
          error.textContent = panel.dataset.error;
          error.hidden = false;
          review.hidden = false;
          try {
            const cartResponse = await fetch(`${panel.dataset.cartUrl}.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
            if (!cartResponse.ok) return;
            const cart = await cartResponse.json();
            if (!Array.isArray(cart.items) || cart.items.some((item) => item.properties?._gd_care_pair === pair)) return;
            button.disabled = false;
            select.disabled = false;
            delete panel.dataset.busy;
          } catch {
            return;
          }
        }
      }, true);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
